import { useCallback, useEffect, useState } from "react";
import { getCommandView, type CommandViewResponse, friendlyFloorStackError } from "../../lib/floorStackApi.js";

export type CommandViewState =
  | { status: "idle" }
  | { status: "loading" }
  | { status: "ready"; data: CommandViewResponse }
  | { status: "error"; message: string };

export function useCommandView(siteId: string | null, floorId: string | null, tenantId: string | null) {
  const [state, setState] = useState<CommandViewState>({ status: "idle" });
  const reload = useCallback(async () => {
    if (!siteId || !floorId) {
      setState({ status: "idle" });
      return;
    }
    setState({ status: "loading" });
    try {
      const data = await getCommandView(siteId, floorId, tenantId);
      setState({ status: "ready", data });
    } catch (err) {
      setState({ status: "error", message: friendlyFloorStackError(err) });
    }
  }, [siteId, floorId, tenantId]);
  useEffect(() => { void reload(); }, [reload]);
  return { state, reload };
}
